export function executeSchedule(parentSubscription, scheduler, work, delay = 0, repeat = false) {
    if (!parentSubscription.closed) {
        const scheduleSubscription = scheduler.schedule(function () {
            work();
            if (repeat) {
                parentSubscription.add(this.schedule(null, delay));
            }
            else {
                this.unsubscribe();
            }
        }, delay);
        parentSubscription.add(scheduleSubscription);
        if (!repeat) {
            return scheduleSubscription;
        }
    }
}
//# sourceMappingURL=executeSchedule.js.map